module.exports = __webpack_public_path__ + "e058528efd898b23def5fda677acb9e7.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/onboarding/icons/school-gray.png
// module id = 1733
// module chunks = 0